import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  isModulesFetching: false,
  modules: [],
  isThemesFetching: false,
  themes: [],
  isProcessCreate: false,
  isProcessConnectModuleLesson: false,
  isCreateComplete: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchThemes]: state => {
      return {
        ...state,
        isThemesFetching: true,
      }
    },
    [actions.fetchThemesSuccess]: (state, action) => {
      return {
        ...state,
        themes: action.result,
        isThemesFetching: false,
      }
    },
    [actions.fetchThemesFailure]: (state, action) => {
      return {
        ...state,
        isThemesFetching: false,
        error: action.error,
      }
    },
    [actions.fetchModules]: state => {
      return {
        ...state,
        isModulesFetching: true,
      }
    },
    [actions.fetchModulesSuccess]: (state, action) => {
      return {
        ...state,
        modules: action.result,
        isModulesFetching: false,
      }
    },
    [actions.fetchModulesFailure]: (state, action) => {
      return {
        ...state,
        isModulesFetching: false,
        error: action.error,
      }
    },
    [actions.createLesson]: state => {
      return {
        ...state,
        isProcessCreate: true,
        error: initialState.error,
      }
    },
    [actions.createLessonSuccess]: state => {
      return {
        ...state,
        isCreateComplete: true,
        isProcessCreate: false,
      }
    },
    [actions.createLessonFailure]: (state, action) => {
      return {
        ...state,
        isProcessCreate: false,
        error: action.error,
      }
    },
    [actions.connectModuleLesson]: state => {
      return {
        ...state,
        isProcessConnectModuleLesson: true,
      }
    },
    [actions.connectModuleLessonSuccess]: state => {
      return {
        ...state,
        isProcessConnectModuleLesson: false,
      }
    },
    [actions.connectModuleLessonFailure]: (state, action) => {
      return {
        ...state,
        isProcessConnectModuleLesson: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
